import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hexToRGBa' })
export class HexToRGBaPipe implements PipeTransform {
  transform(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    let t = `rgb(${r}, ${g}, ${b})`;
    if (alpha) {
      t = `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return t;
  }
}
